export const PageUrl = {
    HOME: "/home",
    TICKET: {
        ROOT: '/orders',
        TICKET_LIST: "/orders/orders-list",
        COMMERCE_ORDER: "/orders/commerce-order",
        ATTENDANCE_DELIVERY: "/orders/attendance-delivery",
        SUBSCRIPTION_CONTRACTS: "/orders/subscription-contracts",
        AUTOMATION: "/orders/Automation",
    },
    USERS: {
        ROOT: '/users',
    },
    ONLINE_BOOKING: {
        ROOT: '/online-booking',
    },
    SERVICE_MANAGEMENT: {
        ROOT: '/services-management',
    },
    REPORTS: {
        ROOT: '/reports'
    },
    GROWTH_AND_MARKETING: {
        ROOT: '/growth',
        PROMO_CODE: '/growth/promo-code',
        LOYALTY: '/growth/loyalty'
    },
    BUSY_TIME: {
        ROOT: '/busy-time',
    },
    OPERATION_SETUP: {
        HOUSING: '/operation-setup/housing',
        ZONES: '/operation-setup/zones',
        SERVICES: '/operation-setup/services',
        FIELD_TEAM: '/operation-setup/field-team',
        DISPATCH: '/operation-setup/dispatch'
    },
    CUSTOMERS: {
        ROOT: '/customers',
        ADD_NEW: '/customers/add-new',
        VIEW: '/customers/view/:id',
        EDIT: '/customers/edit/:id',
    },
    PWA_CONTROL: {
        ROOT: '/pwa-control',
        APPEARANCE: '/pwa-control/appearance',
        OFFERS_MEDIA: '/pwa-control/offers-media',
        SERVICES_CONTROL: '/pwa-control/services-control',
        FEATURES_CARDS: '/pwa-control/features-cards',
        PAGES_EDITOR: '/pwa-control/pages-editor',
    },
    TRIP: {
        ROOT: '/trip',
    },
    PAYMENTS: {
        ROOT: '/payments',
        PAYMENT_GATEWAY: '/payments/payment-gateway',
        ZATCA_INTEGRATION: '/payments/zatca-integration',
    },
}